<template>
  <div class="newUser">
    <ods-button size="medium" @click="newUser">Nuevo Usuario</ods-button>
    <ods-form :model="datosUsuarios" :rules="ticketRules" ref="datosUsuarios">
      <div class="default-form">
        <ods-dialog
            :visible.sync="dialogTableVisible"
            :before-close="handleClose"
            width="50%"
            :append-to-body="true">
                <div class="grid-content bg-purple" style="text-align: left;">
                    <span style="font-weight: $font-weight-regular; font-size: 15px;">Alta de Usuarios</span>
                </div>
                <div v-if="cierre">
                  <ods-alert
                  :title="title || 'Completa todos los campos'"
                  :closable="closable"
                  type="error"
                  :width="width"
                  :center="center"
                  :showIcon="showIcon"
                  :description="description"
                  style="margin-top: 1%;">
                </ods-alert>
                </div>
            <ods-row :gutter="10" style="margin-top: 3%;">
              <ods-col :span="8">
                <ods-form-item prop="usuario">
                  <ods-input
                    class="inputUser"
                    v-model="datosUsuarios.usuario"
                    label="usuario"
                    :maxlength="22"
                    size="hecto"></ods-input>
                  </ods-form-item>
              </ods-col>
              <ods-col :span="8">
                <ods-form-item label="perfil" prop="codperfil">
                    <ods-select v-model="datosUsuarios.codperfil" size="hecto" @change="changePerfil">
                      <ods-option
                        v-for="item in this.profiles"
                        :key="item.valor"
                        :value="item.valor"
                        :label="item.valor + ' - '+ item.descrip">
                      </ods-option>
                    </ods-select>
                </ods-form-item>
              </ods-col>
              <ods-col :span="8">
                <ods-form-item label="perfil navegación" prop="codperfpo">

                    <ods-select v-model="datosUsuarios.codperfpo" size="hecto">
                      <ods-option
                        v-for="item in this.navProfile"
                        :key="item.registro_Numero"
                        :value="item.codperfpo"
                        :label="item.codperfpo + ' - '+ item.desperfpo">
                      </ods-option>
                    </ods-select>

                </ods-form-item>
              </ods-col>
            </ods-row>
            <ods-row :gutter="10" style="margin-top: 2%;">
              <ods-col :span="8">
                <ods-form-item label="holding" prop="holding">
                    <ods-select v-model="datosUsuarios.holding" size="hecto" @change="changeHolding" :disabled="deshabilitaHolding">
                      <ods-option
                        v-for="item in this.lHolding"
                        :key="item.holding"
                        :value="item.holding"
                        :label="item.holding + ' - ' + item.desholding">
                      </ods-option>
                    </ods-select>
                </ods-form-item>
              </ods-col>
              <ods-col :span="8">
                <ods-form-item label="cadena" prop="codcadena">
                    <ods-select v-model="datosUsuarios.codcadena" size="hecto" @change="changeCadena" :disabled="deshabilitaCadena">
                      <ods-option
                        v-for="item in this.lCommerce"
                        :key="item.codcadenal"
                        :value="item.codcadenal"
                        :label="item.codcadenal + ' - ' + item.descadena">
                      </ods-option>
                    </ods-select>
                </ods-form-item>
              </ods-col>
              <ods-col :span="8">
                <ods-form-item label="comercio" prop="codcom">
                    <ods-select v-model="datosUsuarios.codcom" size="hecto" :disabled="deshabilitaComercio">
                      <ods-option
                        v-for="item in this.lCommercial"
                        :key="item.codcom"
                        :value="item.codcom"
                        :label="item.codcom + ' - ' + item.descomercio">
                      </ods-option>
                    </ods-select>
                </ods-form-item>
              </ods-col>
            </ods-row>
            <ods-row :gutter="10" style="margin-top: 2%;">
              <ods-col :span="8">
                <ods-form-item label="nombre" prop="nombre">
                  <ods-input
                    v-model="datosUsuarios.nombre"
                    :maxlength="100"
                    size="hecto"
                    type="text">
                  </ods-input>
                </ods-form-item>
              </ods-col>
              <ods-col :span="8">
                <ods-form-item label="primer apellido" prop="apelli1">
                  <ods-input
                    v-model="datosUsuarios.apelli1"
                    :maxlength="30"
                    size="hecto"
                    type="text">
                  </ods-input>
                </ods-form-item>
              </ods-col>
              <ods-col :span="8">
                <ods-form-item label="segundo apellido" prop="apelli2">
                  <ods-input
                    v-model="datosUsuarios.apelli2"
                    :maxlength="30"
                    size="hecto"
                    type="text">
                  </ods-input>
                </ods-form-item>
              </ods-col>
            </ods-row>
            <ods-row :gutter="10" style="margin-top: 2%;">
              <ods-col :span="8">
                <ods-form-item label="email" prop="email">
                  <ods-input
                    type="email"
                    v-model="datosUsuarios.email"
                    :maxlength="50"
                    size="hecto"></ods-input>
                </ods-form-item>
              </ods-col>
              <ods-col :span="8">
                <ods-form-item label="teléfono móvil" prop="tel_movil">
                  <ods-input
                    v-model="datosUsuarios.tel_movil"
                    size="hecto"
                    maxlength="20"
                    oninput="if(this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                    onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57">
                  </ods-input>
                </ods-form-item>
              </ods-col>
            </ods-row>
                <span slot="footer" class="dialog-footer">
                  <ods-button
                  style="position: absolute; right: 7%; margin-top: -2%;"
                  size="medium"
                  type="secondary;"
                  @click="onSubmit(datosUsuarios, 'datosUsuarios')">guardar</ods-button>
                </span>
        </ods-dialog>
      </div>
    </ods-form>
      <dialog-generic-error
        :message="errorMessage"
        :dialogError="dialogError"
        :before-close-fn="handleCloseSession"
        @dialogClosed="closeDialogError($event)">
      </dialog-generic-error>
      <dialog-generic-success
        :dialogSuccess="dialogSuccess"
        @dialogClosed="closeDialogSuccess($event)">
      </dialog-generic-success>
      <dialog-tex-edit
        :dialogTextEdit="dialogTextEdit"
        :typeImg="aceptar"
        :title="titleNewUser"
        :subTitle="subTitle"
        :codeUser="codeUser"
        :codePass="codePass"
        @dialogClosed="closeDialogText($event)">
      </dialog-tex-edit>
      <dialog-generic-warning
        :dialogError="dialogErrorImg"
        :message="warningMessage"
        :dialogWarning="dialogWarning"
        @dialogClosed="closeDialogWarning($event)">
      </dialog-generic-warning>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import DialogGenericError from '@/components/dialogs/DialogGenericError'
import DialogConfirmSuccess from '@/components/dialogs/DialogConfirmSuccess'
import DialogTexEdit from '@/components/dialogs/DialogTexEdit'
import DialogGenericWarning from '@/components/dialogs/DialogGenericWarning'
import { Utils } from '@/utils/Utils.js'

export default {
  props: ['codcomercio', 'profiles'],
  data () {
    var validateUsuario = (rule, value, callback) => {
      if (value.trim() === '') {
        callback(new Error('Campo obligatorio'))
      } else {
        callback()
      }
    }
    var validateNombre = (rule, value, callback) => {
      if (!value) {
        callback(new Error('Campo obligatorio'))
      } else {
        if (Utils.validateCaracEspecial(value)) {
          callback(new Error('Existen caracteres no permitidos'))
        } else {
          callback()
        }
      }
    }
    var validateApelli1 = (rule, value, callback) => {
      if (!value) {
        callback(new Error('Campo obligatorio'))
      } else {
        if (Utils.validateCaracEspecial(value)) {
          callback(new Error('Existen caracteres no permitidos'))
        } else {
          callback()
        }
      }
    }
    var validateApelli2 = (rule, value, callback) => {
      if (Utils.validateCaracEspecial(value)) {
        callback(new Error('Existen caracteres no permitidos'))
      } else {
        callback()
      }
    }
    var validateTelf = (rule, value, callback) => {
      if (value.trim() === '') {
        callback(new Error('Campo obligatorio'))
      } else {
        callback()
      }
    }
    var validateEmail = (rule, value, callback) => {
      if (!Utils.validateEmail(value)) {
        callback(new Error('Campo obligatorio'))
      } else {
        callback()
      }
    }
    var validateCodperfil = (rule, value, callback) => {
      if (value.trim() === '') {
        callback(new Error('Campo obligatorio'))
      } else {
        callback()
      }
    }
    var validateHolding = (rule, value, callback) => {
      const storageAppData = JSON.parse(sessionStorage.getItem('appParams'))
      const roleHolding = storageAppData.customer_role
      if (roleHolding === '02' || roleHolding === '03') {
        callback()
      } else if (value.trim() === '') {
        callback(new Error('Campo obligatorio'))
      } else {
        callback()
      }
    }
    var validateCadcadena = (rule, value, callback) => {
      const storageAppData = JSON.parse(sessionStorage.getItem('appParams'))
      const roleCadena = storageAppData.customer_role
      value = value.toString()
      if (roleCadena === '03') {
        callback()
      } else if (value.trim() === '' && rule.required) {
        callback(new Error('Campo obligatorio'))
      } else {
        callback()
      }
    }
    var validateCodcom = (rule, value, callback) => {
      if (value.trim() === '' && rule.required) {
        callback(new Error('Campo obligatorio'))
      } else {
        callback()
      }
    }
    return {
      aceptar: 'aceptar',
      titleNewUser: 'Usuario Creado',
      subTitle: '',
      codePass: '',
      codeUser: '',
      dialogTableVisible: false,
      deshabilitaHolding: true,
      deshabilitaCadena: true,
      deshabilitaComercio: true,
      role: '',
      title: 'Completa todos los campos',
      width: '200',
      cierre: false,
      closable: false,
      center: false,
      showIcon: false,
      description: '',
      datosUsuarios: {
        apelli1: '',
        apelli2: '',
        codcadena: '',
        codcom: '',
        codperfil: '',
        email: '',
        holding: '',
        nombre: '',
        codperfpo: '',
        tel_movil: '',
        usuario: ''
      },
      ticketRules: {
        usuario: [
          { required: true, validator: validateUsuario, trigger: 'blur' }
        ],
        nombre: [
          { required: true, validator: validateNombre, trigger: 'blur' }
        ],
        apelli1: [
          { required: true, validator: validateApelli1, trigger: 'blur' }
        ],
        apelli2: [
          { required: true, validator: validateApelli2, trigger: 'blur' }
        ],
        tel_movil: [
          { required: true, validator: validateTelf, trigger: 'blur' }
        ],
        email: [
          { required: true, validator: validateEmail, trigger: 'blur' }
        ],
        holding: [
          { required: false, validator: validateHolding, trigger: 'change' }
        ],
        codperfil: [
          { required: true, validator: validateCodperfil, trigger: 'change' }
        ],
        codcadena: [
          { required: false, validator: validateCadcadena, trigger: 'change' }
        ],
        codcom: [
          { required: false, validator: validateCodcom, trigger: 'change' }
        ]
      },
      dialogError: false,
      dialogErrorImg: false,
      dialogSuccess: false,
      dialogTextEdit: false,
      dialogWarning: false,
      hasErrors: false,
      errorMessage: '',
      navProfile: [],
      warningMessage: ''
    }
  },
  methods: {
    onSubmit (datosUsuarios, nombreFormulario) {
      this.$refs[nombreFormulario].validate((valid) => {
        if (valid) {
          const codPerfilEnvio = datosUsuarios.codperfil.substring(0, 2)
          const holdingEnvio = datosUsuarios.holding ? datosUsuarios.holding.substring(0, 3) : datosUsuarios.holding = '001'
          let codCadenaEnvio = datosUsuarios.codcadena ? datosUsuarios.codcadena.toString() : datosUsuarios.codcadena = '001'
          if (codCadenaEnvio === 'Sel') {
            codCadenaEnvio = 'Seleccionar'
          }
          const codComEnvio = datosUsuarios.codcom.substring(0, 15)
          datosUsuarios.codperfil = codPerfilEnvio
          datosUsuarios.holding = holdingEnvio
          datosUsuarios.codcadena = codCadenaEnvio
          datosUsuarios.codcom = codComEnvio
          datosUsuarios.usuario = datosUsuarios.usuario.toUpperCase()

          this.$store.dispatch('insertUser', datosUsuarios).then(r => {
            this.cierre = false
            const user = { ...datosUsuarios }
            if (r.data.runServiceResponse.return.retorno !== '078') {
              this.refreshListUsers()
              this.handleClose()
              if (r.error === true) {
                this.displayErrorDialog(r.data.runServiceResponse.return.descRetorno)
              } else if (r.warning === true) {
                this.displayErrorWarning(r.data.runServiceResponse.return.descRetorno)
              } else {
                // this.displayConfirmSuccess()
                this.displayTextEdit(
                  user.usuario,
                  r.data.runServiceResponse.return.registros.tokenpasswd,
                  `Hemos creado el usuario ${user.usuario} asignado a ${user.nombre} ${user.apelli1}. Por favor indícale que su clave inicial es:`)
              }
            } else {
              // datosUsuarios.codperfil = this.getElementComboPerfil(datosUsuarios.codperfil)
              // datosUsuarios.codperfpo = this.getElementComboNav(datosUsuarios.codperfpo)
              this.dialogErrorImg = true
              this.displayErrorWarning('USUARIO YA EXISTENTE')
              // this.changePerfil()
            }
          }).catch(e => {
            console.error('Error in list Users - App', e)
          })
        } else {
          this.cierre = true
          return false
        }
      })
    },

    getElementComboPerfil (elem) {
      const combo = this.profiles.find(
        res => res.valor === elem
      )
      return combo.valor + ' - ' + combo.descrip
    },

    getElementComboNav (elem) {
      const combo = this.navProfile.find(
        res => res.codperfpo === elem
      )
      return combo.codperfpo + ' - ' + combo.desperfpo
    },

    displayErrorWarning (msg) {
      this.warningMessage = `${msg}`
      this.dialogWarning = true
    },

    closeDialogWarning (e) {
      this.dialogWarning = e
    },

    newUser () {
      this.dialogTableVisible = true
      this.executeListNavProfile()
    },

    executeListNavProfile () {
      this.$store.dispatch('listNavProfil')
        .then((res) => {
          this.navProfile = res
        })
    },

    executeSelectHolding (selectedRole) {
      this.$store.dispatch('listHolding').then(r => {
        this.datosUsuarios.codcadena = 'Seleccionar'
        this.datosUsuarios.codcom = 'Seleccionar'
        if (r.error === true) {
          // this.displayErrorDialog(r.data.runServiceResponse.return.descRetorno)
          this.displayErrorWarning(r.data.runServiceResponse.return.descRetorno)
        }
      }).catch(e => {
        console.error('Error en listProfile- App', e)
      })
    },
    executeSelectCadena (selectedRole, selectedHolding) {
      this.$store.dispatch('listCommerce', selectedHolding).then(r => {
        this.datosUsuarios.codcom = 'Seleccionar'
        if (selectedRole === '03' || selectedRole === '04') {
          this.executeSelectComercio(selectedRole, r.data.runServiceResponse.return.registros.codcadenal)
        }
        if (r.error === true) {
          this.displayErrorDialog(r.data.runServiceResponse.return.descRetorno)
        }
      }).catch(e => {
        console.error('Error en listHolding- App', e)
      })
    },
    executeSelectComercio (selectedRole, selectedCadena) {
      this.$store.dispatch('listCommercial', selectedCadena).then(r => {
        if (r.error === true) {
          this.displayErrorDialog(r.data.runServiceResponse.return.descRetorno)
        }
      }).catch(e => {
        console.error('Error in confirm token - App', e)
      })
    },
    changePerfil () {
      this.limpiarCampos(this.$data.datosUsuarios.codperfil)
      switch (this.$data.datosUsuarios.codperfil.substring(0, 2)) {
        case '01':
          this.deshabilitaHolding = false
          this.deshabilitaCadena = true
          this.deshabilitaComercio = true
          this.executeSelectHolding()
          break
        case '02':
          this.deshabilitaHolding = true
          this.deshabilitaCadena = false
          this.deshabilitaComercio = true
          if (this.role === '01' || this.role.toString() === '99') {
            this.deshabilitaHolding = false
            this.deshabilitaCadena = true
            this.deshabilitaComercio = true
            this.executeSelectHolding()
            // this.executeSelectHolding(this.$data.datosUsuarios.codperfil.substring(0, 2))
          } else {
            this.executeSelectCadena()
          }
          break
        case '03':
          this.deshabilitaHolding = true
          this.deshabilitaCadena = true
          this.deshabilitaComercio = false
          if (this.role === '01' || this.role.toString() === '99') {
            this.deshabilitaHolding = false
            this.deshabilitaCadena = true
            this.deshabilitaComercio = true
            this.executeSelectHolding()
            // this.executeSelectHolding(this.$data.datosUsuarios.codperfil.substring(0, 2))
          } else if (this.role === '02') {
            this.deshabilitaHolding = true
            this.deshabilitaCadena = false
            this.deshabilitaComercio = true
            this.executeSelectCadena()
            //  this.executeSelectCadena(this.$data.datosUsuarios.codperfil.substring(0, 2))
          } else {
            this.executeSelectComercio()
          }
          break
        case '04':
          this.deshabilitaHolding = true
          this.deshabilitaCadena = true
          this.deshabilitaComercio = false
          if (this.role === '01' || this.role.toString() === '99') {
            this.deshabilitaHolding = false
            this.deshabilitaCadena = true
            this.deshabilitaComercio = true
            this.executeSelectHolding()
            //  this.executeSelectHolding(this.$data.datosUsuarios.codperfil.substring(0, 2))
          } else if (this.role === '02') {
            this.deshabilitaHolding = true
            this.deshabilitaCadena = false
            this.deshabilitaComercio = true
            this.executeSelectCadena()
            //  this.executeSelectCadena(this.$data.datosUsuarios.codperfil.substring(0, 2))
          } else {
            this.executeSelectComercio()
          }
          break
        default:
          break
      }
    },
    changeHolding () {
      // this.datosUsuarios.holding = this.$data.datosUsuarios.holding + '.'
      if (this.$data.datosUsuarios.codperfil.substring(0, 2) === '01' || this.$data.datosUsuarios.codperfil.substring(0, 2) === '99') {
      } else {
        this.$store.dispatch('listCommerce', this.$data.datosUsuarios.holding.substring(0, 3)).then(r => {
          this.deshabilitaCadena = false
          this.datosUsuarios.codcadena = ''
          if (r.error === true) {
            this.displayErrorDialog(r.data.runServiceResponse.return.descRetorno)
          }
        }).catch(e => {
          console.error('Error en listHolding- App', e)
        })
      }
    },
    changeCadena () {
      // this.datosUsuarios.codcadena = this.$data.datosUsuarios.codcadena + '.'
      if (this.$data.datosUsuarios.codperfil.substring(0, 2) === '02') {
      } else {
        this.$store.dispatch('listCommercial', this.$data.datosUsuarios.codcadena).then(r => {
          this.deshabilitaComercio = false
          this.datosUsuarios.codcom = ''
          if (r.error === true) {
            this.displayErrorDialog(r.data.runServiceResponse.return.descRetorno)
          }
        }).catch(e => {
          console.error('Error in confirm token - App', e)
        })
      }
    },
    limpiarCampos (codperfil) {
      this.datosUsuarios.holding = ''
      this.datosUsuarios.codcadena = ''
      this.datosUsuarios.codcom = ''
      this.datosUsuarios.codperfil = codperfil
    },
    handleClose () {
      this.$refs.datosUsuarios.resetFields()
      this.dialogTableVisible = false
      this.deshabilitaHolding = true
      this.deshabilitaCadena = true
      this.deshabilitaComercio = true
      this.cierre = false
    },
    refreshListUsers () {
      this.$store.dispatch('listUsers', { codcom: this.codcomercio }).then(r => {
        if (r.error === true) {
          this.displayErrorDialog(r.data.runServiceResponse.return.descRetorno)
        } else {
          if (r.vacio === true) {
            this.$emit('mostrarVentanaUsuario', false)
          } else {
            this.$emit('mostrarVentanaUsuario', true)
          }
        }
      }).catch(e => {
        console.error('Error in list Users - App', e)
      })
    },
    handleCloseSession () {
      this.$store.dispatch('logout')
    },
    closeDialogError (e) {
      this.dialogError = e
      this.handleCloseSession()
    },
    closeDialogSuccess (e) {
      this.$emit('success', e)
      this.dialogSuccess = e
    },

    closeDialogText (e) {
      // this.$emit('success', e)
      this.dialogTextEdit = e
    },

    displayErrorDialog (msg) {
      this.errorMessage = `${msg}`
      this.dialogError = true
    },
    displayConfirmSuccess () {
      this.dialogSuccess = true
    },
    displayTextEdit (user, pass, msg) {
      this.dialogTextEdit = true
      this.codeUser = user
      this.codePass = pass
      this.subTitle = msg
    }
  },
  ...mapGetters([
    'getListProfileData',
    'getListHoldingData',
    'getListCommerceData',
    'getlistCommercialData'
  ]),
  computed: {
    lHolding () {
      let datosHolding = []
      if (this.$store.getters.getListHoldingData !== undefined) {
        if (this.$store.getters.getListHoldingData !== '') {
          datosHolding = this.$store.getters.getListHoldingData
        }
      }
      return datosHolding
    },
    lCommerce () {
      let datosComerce = []
      if (this.$store.getters.getListCommerceData !== undefined) {
        if (this.$store.getters.getListCommerceData !== '') {
          datosComerce = this.$store.getters.getListCommerceData
        }
      }
      return datosComerce
    },
    lCommercial () {
      let datosCommercial = []
      if (this.$store.getters.getlistCommercialData !== undefined) {
        if (this.$store.getters.getlistCommercialData !== '') {
          datosCommercial = this.$store.getters.getlistCommercialData
        }
      }
      return datosCommercial
    }
  },

  watch: {
    deshabilitaHolding (val) {
      if (val) {
        this.ticketRules.holding[0].required = false
      } else {
        this.ticketRules.holding[0].required = true
      }
    },
    deshabilitaCadena (val) {
      if (val) {
        this.ticketRules.codcadena[0].required = false
      } else {
        this.ticketRules.codcadena[0].required = true
      }
    },
    deshabilitaComercio (val) {
      if (val) {
        this.ticketRules.codcom[0].required = false
      } else {
        this.ticketRules.codcom[0].required = true
      }
    }
  },

  components: {
    DialogGenericError,
    'dialog-generic-success': DialogConfirmSuccess,
    DialogTexEdit,
    'dialog-generic-warning': DialogGenericWarning
  },
  mounted () {
    const storageAppData = JSON.parse(sessionStorage.getItem('appParams'))
    this.role = storageAppData.customer_role
  }
}
</script>

<style lang="scss" scoped>
    .prue {
    text-align: right;
    font-size: 9px;
    color: #6E767D;
    padding: 0 12px 0 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    display: block;
    letter-spacing: .5px;
    float: left;
    line-height: 16px;
    margin-bottom: 8px;
    font-weight: 500;
    }
/deep/  .ods-dialog__header {
    padding: 0px 0 16px;
    }
/deep/  .ods-dialog__footer {
    padding: 55px 0 4px;
    text-align: right;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    }
/deep/  .ods-form-item__label {
    text-align: left;
    font-size: 9px;
    color: #6E767D;
    padding: 0 12px 0 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    display: block;
    letter-spacing: .5px;
    float: unset;
    line-height: 16px;
    margin-bottom: 8px;
    }
    .newUser{
      display: flex;
      justify-content: flex-end;
    }
/deep/.inputUser{
      .ods-input__inner{
        text-transform: uppercase;
      }
    }
</style>
